module.exports = __webpack_public_path__ + "img/good2.f4dfa041.png";